
<template>
    <v-content v-if="utility.unhide">
        <v-container fluid fill-height>
            <Login action="login"/>
        </v-container>
    </v-content>
</template>

<script>
    import Login from "./Login";
    export default {
        components: {Login},
        data: () => ({
            utility: {unhide:false},
        }),
        methods: {
        },
        created: function () {
            let this_ = this
            this_.$store.dispatch('checkLogin', {}).then(function (response) {
                if (response.status === 200) this_.$router.push(this_.$route.query.redirect || '/')
                //this_.$router.push('/home')
                else this_.utility.unhide = true
            })
        }
    }
</script>